import React from 'react';
import { Home, Car, Smartphone, PlusCircle, ArrowRight, ShoppingBag } from 'lucide-react';

const PostAdSection = () => {
  const handleNavigate = (path) => {
    window.location.href = path;
  };

  const categories = [
    { id: 'house', name: 'Ev Elanı', Icon: Home, color: 'bg-emerald-500', shadow: 'shadow-emerald-500/20' },
    { id: 'car', name: 'Maşın Elanı', Icon: Car, color: 'bg-blue-500', shadow: 'shadow-blue-500/20' },
    { id: 'phone', name: 'Telefon Elanı', Icon: Smartphone, color: 'bg-purple-500', shadow: 'shadow-purple-500/20' },
    { id: 'other', name: 'Digər', Icon: ShoppingBag, color: 'bg-orange-500', shadow: 'shadow-orange-500/20' },
  ];

  return (
    <section className="
      relative overflow-hidden p-8 md:p-16 rounded-[3.5rem] shadow-2xl
      bg-white text-gray-900 border border-gray-100
      dark:bg-[#0f172a] dark:text-white dark:border-white/5
      transition-all duration-700
    ">
      {/* Dark mode background effects */}
      <div className="hidden dark:block">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-600/20 rounded-full blur-[100px]" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-purple-600/10 rounded-full blur-[100px]" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-[0.03]" />
      </div>

      <div className="flex flex-col lg:flex-row items-center gap-16 relative z-10">
        {/* Categories */}
        <div className="w-full lg:w-1/2 grid grid-cols-2 gap-6">
          {categories.map((cat) => (
            <div
              key={cat.id}
              onClick={() => handleNavigate('/addPagenation')}
              className="
                group p-8 rounded-[2.5rem] flex flex-col items-center justify-center gap-4
                cursor-pointer transition-all duration-300 hover:-translate-y-2
                bg-gray-50 hover:bg-white hover:shadow-xl
                dark:bg-white/5 dark:hover:bg-white/10 dark:border dark:border-white/10
              "
            >
              <div className={`${cat.color} ${cat.shadow} p-5 rounded-2xl text-white group-hover:rotate-12 transition-transform`}>
                <cat.Icon size={28} strokeWidth={2.5} />
              </div>

              <span className="font-black text-xs uppercase tracking-widest text-gray-600 dark:text-gray-300 text-center">
                {cat.name}
              </span>
            </div>
          ))}
        </div>

        {/* Right content */}
        <div className="w-full lg:w-1/2 text-center lg:text-left space-y-8">
          <div className="
            inline-flex items-center gap-2 px-5 py-2.5 rounded-full
            text-[10px] font-black uppercase tracking-[0.2em]
            bg-blue-50 text-blue-600
            dark:bg-blue-500/20 dark:text-blue-400
          ">
            <PlusCircle size={14} /> Elanını İndi Yerləşdir
          </div>

          <h2 className="text-5xl md:text-6xl font-black leading-[1.1]">
            Hər şeyi <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400">
              Sürətli Satın!
            </span>
          </h2>

          <p className="text-xl font-medium max-w-xl text-gray-500 dark:text-gray-400">
            Ev, maşın, telefon və ya hər hansı bir əşya...
            Sadə, sürətli və tamamilə pulsuz.
          </p>

          <div className="flex flex-col sm:flex-row gap-5 pt-6">
            <button
              onClick={() => handleNavigate('/addPagenation')}
              className="
                group flex items-center justify-center gap-4
                bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400
                text-white px-12 py-6 rounded-[2rem] font-black text-xl
                shadow-2xl shadow-blue-500/40 active:scale-95 transition
              "
            >
              Elan Yerləşdir
              <ArrowRight size={24} className="group-hover:translate-x-2 transition-transform" />
            </button>

            <button
              onClick={() => handleNavigate('/rules')}
              className="
                px-10 py-6 rounded-[2rem] font-bold text-lg border-2
                border-gray-200 text-gray-600 hover:bg-gray-50
                dark:border-white/10 dark:text-gray-300 dark:hover:bg-white/5
                transition
              "
            >
              Qaydalar
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostAdSection;
